import { useQuery, queryOptions } from '@tanstack/react-query';
import { getCheckoutState } from 'merchant-api/checkout';
import { useEffect, useState } from 'react';
import { spiceroad } from '..';

interface InstitutionSupportData {
  institutionSupported: boolean;
}

const getInstitutionSupport = (routingNumber: string) =>
  spiceroad
    .get<InstitutionSupportData>('/v1/plaid/institutionSupport', {
      params: { routingNumber },
    })
    .then((res) => res.data);

export const getInstitutionSupportOpts = (routingNumber: string) =>
  queryOptions<InstitutionSupportData>({
    queryKey: ['institutionSupport', routingNumber],
    queryFn: () => getInstitutionSupport(routingNumber),
  });

export function checkInstitutionSupport() {
  const { checkoutData, isErrorCheckoutState, isLoadingCheckoutState } =
    getCheckoutState();
  const [routingNumber, setRoutingNumber] = useState<string>();

  useEffect(() => {
    if (checkoutData?.routingNumber) {
      setRoutingNumber(checkoutData.routingNumber);
    }
  }, [checkoutData]);

  const query = useQuery({
    ...getInstitutionSupportOpts(routingNumber!),
    enabled: !!routingNumber,
  });
  const { data, error, isLoading } = query;

  const institutionSupportError = error || isErrorCheckoutState;
  const isLoadingInstitutionSupport =
    isLoading || (isLoadingCheckoutState && routingNumber == null);
  return {
    isInstitutionSupported: data?.institutionSupported,
    error: institutionSupportError,
    isLoadingInstitutionSupport: isLoadingInstitutionSupport,
  };
}

export default checkInstitutionSupport;
